module.exports = __webpack_public_path__ + "img/unlock.19f43be3.svg";